export const modifiedAddress  = (str) => {
    if (str){
        return str.replace(/[0-9]/g, '*')
    }
    return ''
}